/* eslint-disable @typescript-eslint/no-magic-numbers */
import { AmountType } from '@shared/cards-types';

export const creditShared = {
    layout: {
        productInfo: {
            showBalanceAndOutstandingAmount: true,
        },
    },
    reservations: {
        useCardIdEnabled: true,
        amountSender: true,
        description: true,
        status: true,
        info: true,
    },
    supplementary: {
        enabled: true,
    },
    functions: {
        tpLimits: {
            doubleFetchEnabled: true,
            doubleFetchTimeout: 5000,
            limitValues: {
                atm: [5000, 10000, 20000],
                pos: [1000, 5000, 10000],
                internet: [1000, 5000, 10000],
            },
            editor: {
                confirmationEnabled: true,
                confirmationLanguages: ['cs', 'en'],
                limitTypes: ['ATM', 'POS', 'INTERNET'],
            },
            validations: {
                ATM: {
                    divisible: {
                        enabled: true,
                    },
                },
                POS: {
                    divisible: {
                        enabled: true,
                    },
                },
                INTERNET: {
                    divisible: {
                        enabled: true,
                    },
                    biggerAsPOS: {
                        enabled: true,
                    },
                },
            },
        },
        payUp: {
            receiverNeeded: true,
            ibanField: 'cz-iban',
            bicField: 'cz-bic',
            validAccounts: {
                domesticOrOwnTransferAllowed: true,
                currentAndSavingsAccounts: true,
            },
            showPaidAmounts: true,
            hideMinimalMonthlyAmount: true,
            suggestionAmounts: [
                AmountType.DRAWN_AMOUNT,
                AmountType.REMAINING_OUTSTANDING_AMOUNT,
                AmountType.MINIMAL_MONTHLY_AMOUNT,
                AmountType.OVER_DUE_AMOUNT,
            ],
        },
    },
    smallInfoBox: {
        hideInactiveBalance: true,
    },
};
